import { render, staticRenderFns } from "./WsStudyGroupTags.vue?vue&type=template&id=7819f46a"
import script from "./WsStudyGroupTags.vue?vue&type=script&lang=js"
export * from "./WsStudyGroupTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports